// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"DownloadButton_buttonWrapper__luLv5","buttonText":"DownloadButton_buttonText__4PyGG"};